import { useQuery } from '@tanstack/react-query';
import { DEFAULT_SCHEDULE, type WeeklySchedule } from '@/lib/storeSchedule';

export interface StoreStatus {
  isOpen: boolean;              // Manual open/closed switch — closed blocks checkout
  closureMessage?: string;
  scheduledOpenTime?: Date;
  schedule: WeeklySchedule;     // Weekly program (index 0 = Monday)
}

// Default to open on error to avoid blocking customers
const FALLBACK_STATUS: StoreStatus = { isOpen: true, schedule: DEFAULT_SCHEDULE };

export function useStoreStatus() {
  const query = useQuery<StoreStatus>({
    queryKey: ['store-status'],
    queryFn: async () => {
      const response = await fetch('/api/store-status');
      if (!response.ok) {
        throw new Error('Failed to check store status');
      }
      const data = await response.json();
      return { ...data, schedule: data.schedule ?? DEFAULT_SCHEDULE };
    },
    staleTime: 60 * 1000,
    retry: false,
  });

  if (query.error) {
    console.error('Error checking store status:', query.error);
  }

  return {
    status: query.data ?? (query.isError ? FALLBACK_STATUS : null),
    loading: query.isPending,
    error: query.error ? query.error.message : null,
  };
}
